// extracted by mini-css-extract-plugin
module.exports = {"container":"_j1","image":"_j2","content":"_j3","title":"_j4","text":"_j5","readMore":"_j6","button":"_j7"};